import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "cte-date" }
const _hoisted_2 = { class: "uk-margin-remove" }
const _hoisted_3 = ["uk-tooltip"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "uk-label uk-label-danger" }
const _hoisted_7 = { class: "uk-label uk-label-danger" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass(["cte-row", _ctx.rowStatusClass])
  }, [
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.row.date?.replace('/2026 at ', ' ').replace(' PDT', '').replace(' PST', '')), 1),
        (_ctx.row.collapsedCount > 0)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "cte-collapse-icon",
              "uk-tooltip": _ctx.collapseTooltip
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "circle-info" })
            ], 8, _hoisted_3))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("span", {
        class: _normalizeClass(["uk-label", [_ctx.hasFieldChangedClass('yard_status'), _ctx.getIsAvailable() ? 'uk-label-success' : 'uk-label-danger']])
      }, _toDisplayString(_ctx.getIsAvailable() ? "YES":"NO"), 3)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.hasFieldChangedClass('yard_status'))
      }, _toDisplayString(_ctx.getYardLocation()), 3)
    ]),
    (_ctx.isClearedCustoms(_ctx.row.event['customs']))
      ? (_openBlock(), _createElementBlock("td", _hoisted_4, [
          _createElementVNode("p", null, [
            _createElementVNode("span", {
              class: _normalizeClass(["uk-label uk-label-success", _ctx.hasFieldChangedClass('customs')])
            }, _toDisplayString(_ctx.row.event['customs']), 3)
          ])
        ]))
      : (_openBlock(), _createElementBlock("td", _hoisted_5, [
          (
          _ctx.row.event['customs'].includes('Held') ||
          _ctx.row.event['customs'].includes('NONE') ||
          _ctx.row.event['customs'].includes('HELD') ||
          _ctx.row.event['customs'].includes('HOLD') ||
          _ctx.row.event['customs'].includes('NONE') ||
          _ctx.row.event['customs'].includes('CUST EXAM')
        )
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: _normalizeClass(_ctx.hasFieldChangedClass('customs'))
              }, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.row.event['customs']), 1)
              ], 2))
            : (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: _normalizeClass(["uk-label uk-label-success", _ctx.hasFieldChangedClass('customs')])
              }, _toDisplayString(_ctx.row.event['customs']), 3))
        ])),
    _createElementVNode("td", null, [
      (
          _ctx.row.event['line'].includes('Held') ||
          _ctx.row.event['line'].includes('Hold') ||
          _ctx.row.event['line'].includes('NONE')
        )
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: _normalizeClass(_ctx.hasFieldChangedClass('line'))
          }, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.row.event['line']), 1)
          ], 2))
        : (_ctx.row.event['line'].includes('PAID'))
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
              _createElementVNode("span", {
                class: _normalizeClass(["uk-label uk-label-success", _ctx.hasFieldChangedClass('line')])
              }, _toDisplayString(_ctx.row.event['line']), 3)
            ]))
          : (_ctx.row.event['line'].includes('Released'))
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                _createElementVNode("span", {
                  class: _normalizeClass(["uk-label uk-label-success", _ctx.hasFieldChangedClass('line')])
                }, _toDisplayString(_ctx.row.event['line']), 3)
              ]))
            : (_openBlock(), _createElementBlock("p", {
                key: 3,
                class: _normalizeClass(["uk-label uk-label-success", _ctx.hasFieldChangedClass('line')])
              }, _toDisplayString(_ctx.row.event['line']), 3))
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("span", {
        class: _normalizeClass(["uk-label", 
          [
            _ctx.row.event['terminal'] ? _ctx.hasFieldChangedClass('terminal') : '',
            ['no', 'none'].includes(_ctx.row.event['terminal'].trim().toLowerCase()) ? 'uk-label-success' : 'uk-label-danger'
          ]])
      }, _toDisplayString(_ctx.row.event['terminal']), 3)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.hasFieldChangedClass('usda'))
      }, _toDisplayString(_ctx.row.event['usda']), 3)
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("td", null, " ... ", -1)),
    _createElementVNode("td", null, [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.hasFieldChangedClass('demurrage_amount'))
      }, _toDisplayString(_ctx.row.event['demurrage_amount']), 3)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.hasFieldChangedClass('demurrage_lfd'))
      }, _toDisplayString(_ctx.row.event['demurrage_lfd']), 3)
    ])
  ], 2))
}